import { render, staticRenderFns } from "./ProductSelector.vue?vue&type=template&id=29da9cee&scoped=true"
import script from "./ProductSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductSelector.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProductSelector.vue?vue&type=style&index=0&id=29da9cee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29da9cee",
  null
  
)

export default component.exports